import _ from 'lodash';
import crypto from 'crypto';

const randomPassword = () => {
	return crypto.randomBytes(4).toString('hex');
}

const ab2str = (buf) => {
	return String.fromCharCode.apply(null, new Uint8Array(buf));
}

const swapItem = (l, s, e) => {
	const list = [...l];
	const item = list[s];
	list.splice(s, 1);
	list.splice(e, 0, item);
	return list;
}

const saveFile = (resp, filename) => {
	try {
		const { data } = resp;
		const blob = new Blob([data]);
		if (resp.status === 200 && (blob instanceof Blob)) {
			const url = window.URL.createObjectURL(blob);
			const link = document.createElement('a');
			document.body.appendChild(link);
			link.href = url;
			link.setAttribute('download', filename);
			link.click();
		} else {
			// const obj =
			JSON.parse(ab2str(data));
			// console.log(obj);
		}
	} catch (error) {
		console.log({ error });
	}
}

const validateEmail = (str) => {
	const string = _.toString(str);
	let regex = /^\w+[\w+.'"_-]*@([\w-]+\.)*\w+[\w-]*\.([a-z]{2,4}|\d+)$/gi;
	return regex.test(string);
}

export { randomPassword, saveFile, swapItem, validateEmail };
